import router from 'Plugins/router'
import _this from '@/business/main'
import { localset, localget } from 'Utils/storage.js'
import axiosInstance from 'Plugins/axios'
import api from 'Plugins/api'
import { parseQueryString } from 'Utils/string.js'
import store from 'Plugins/store'

import { getddCode } from 'Utils/dingTalk.js'
import Business from '@/business/utils/business'
import { isGat } from 'Utils/gattools'
import { FUKA_CONFIG } from 'Config/index'

const fixedRoute = ['/login','/Invitation', '/register', '/resetPassword', '/resetPassword/firstStep', '/resetPassword/secondStep', '/resetPassword/thirdStep','/home','/userCenter/message','/approvalList','/userCenter','/trace']

// 特殊token处理，由于上面注入拦截器放到了异步，不会每次都执行，除非链接是新的重复用过的无效
async function getTeshuToken() {
  const urlParams = parseQueryString()
  if(urlParams.loginType && urlParams.loginType == '10' && urlParams.ssotoken) {
    urlParams.app_from && localset('loginType', urlParams.app_from)
    localset('access_token', urlParams.ssotoken)
    axiosInstance.defaults.headers['token'] = urlParams.ssotoken
    store.dispatch('getUserInfo').then(() => {
      redirect(urlParams)
    })
  }
}
getTeshuToken()

export function routerBeforeEachFunc (to, from, next) {
  var url=parseQueryString()
  var token = ''
  if (to.query.token) {
    token = to.query.token
    localset('access_token', token)
    axiosInstance.defaults.headers['token'] = token
    store.dispatch('getUserInfo')
  } else if (url.token) {
    token = url.token
    localset('access_token', token)
    axiosInstance.defaults.headers['token'] = token
    store.dispatch('getUserInfo')
  }else {
    token = localget('access_token') || ''
    axiosInstance.defaults.headers['token'] = token
  }

  // url参数信息保存
  if (url && url !== {}) {
    let param = localget('query_param')
    if (param) {
      Object.assign(param, url)
    } else {
      param = url
    }
    localset('query_param', JSON.stringify(param))
  }

  //微信公众号单点登录
  if (to.query.from === 'wxgzh' || url.from === 'wxgzh') {
    weixinLogin(url || to.query, function () {
      tokenVaildNext()
    })
  } else if (url.openid) {
    localset('openId', url.openid)
    tokenVaildNext()
    // 标准单点登录
  } else if (to.query.loginType || url.loginType) {
    standardSSO(to.query||url,function(){
      tokenVaildNext()
    })
  } else if(to.query.from=='dingtalk'){
    dingtalkFun(to.query||url,function(){
      tokenVaildNext()
    })
  } else if(url.state && url.state.split('#')[0]=='fk'){
    fkLogin(url||'',function(){
      tokenVaildNext()
    })
  }else{
    // 正常
    tokenVaildNext()
  }

  function tokenVaildNext() {
    if (isGat()) {
      if (from.name == 'tkChangeCmp' && to.name == 'tkChangeApply') {//改签成功的回退浏览器
        router.push({path: '/allOrder?findType=1'});
      }
      if (from.name == 'tkRefundCmp' && to.name == 'tkRefundApply') {//退票成功的回退浏览器
        router.push({path: '/allOrder?findType=1'});
      }
    }

    // 路由拦截
    // 未登录情况 去非登录页（首页、消息、待办、我的除外），跳转到登录页
    if(fixedRoute.indexOf(to.path) === -1 && !token) {
      router.push({name: 'login'})
    }

    // 已登录情况 再去登录页，跳转到首页
    if(to.path === '/login' && token) {
      router.push({name: 'home'})
    }

    if(!_this) {
      next()
    } else {
      // 判断路由 index 设定的层级大小，切换页面切换效果
      if(to.meta.index < from.meta.index) {
        _this.$store.commit('SET_TRANSITION', 'turn-off')
      } else if(to.meta.index > from.meta.index) {
        _this.$store.commit('SET_TRANSITION', 'turn-on')
      } else {
        _this.$store.commit('SET_TRANSITION', '')
      }
      next()
    }
  }
}

function fail () {
  window.location.href = window.location.origin + '/#/login'
}

function failed () {
  window.location.href = window.location.origin + '/#/login'
  window.location.reload()
}

function home () {
  window.location.href = window.location.origin + '/#/home'
  window.location.reload()
}

// 标准单点登录
function standardSSO(req, callback) {
  var param = {}
  if (!req.ssotoken || (req.ssotoken && req.ssotoken.length != 32)) {
    fail(callback)
    throw '-1|token失效！'
  } else {
    param.loginName = req.ssotoken
    param.password = req.ssotoken
    param.loginType = '10'
  }

  //将登录token缓存到浏览器本地储存
  axiosInstance.defaults.headers['token'] = req.ssotoken
  localset('access_token', req.ssotoken)
  localset('loginType', req.app_from || '')

  // 获取员工信息
  api['user/getLoginUserInfo']({
    refresh: 1,
  }).then((res) => {
    if (_this) {
      _this.$store.commit('SET_USERINFO', res.data)
    }
    localset('userInfo', res.data)
    if (res.errCode == 100 || res.errCode == 101) {
      alert('token失效！')
      fail(callback)
    }
    redirect(req, callback)
  }).catch(() => {
    console.log('failed')
    fail(callback)
  })
}

// 钉钉获取code权限码
function dingtalkFun (query) {
  let corpId = query.corpid
  let targetModule = query.targetModule || '1'
  let loginCli = query.loginCli || ''
  let workItemId = query.workItemId || ''
  let orderNo = query.orderNo || ''
  let orderId = query.orderId || ''
  let travelNo = query.travelNo || ''
  if(corpId){
    getddCode(corpId,code => {
      window.location.href = 'https://oa.qhtxtrip.com/dingtalk/sso/dd/login?code='+code+'&corpId='+corpId+'&targetModule='+targetModule+'&loginCli='+loginCli+'&workItemId='+workItemId+'&orderNo='+orderNo+'&orderId='+orderId+'&travelNo='+travelNo
    })
  }
}

//小程序
// function miniProgram (query) {
// 	api['user/getMinOpenId']({
// 		'code': query.code,
// 		'companySuper': query.compId || '',
// 		'corpId': query.corpId || '',
// 		'czly': 1,//操作来源 0公众号 1小程序  已废弃 只限公众号使用
// 	}).then((res) => {
// 		var openId = res.data ? res.data.openid : ''
// 		if (openId) { //如果openid 存在 ； 验证是否存在企业表中，绑定员工
// 			localset('openId', openId)
// 			api['user/wxLogin']({
// 				'openId': openId,
// 				'compId': query.compId
// 			}).then((res1) => {
// 				var token = res1.data || ''
// 				if (token) { // 如果验证通过；存储token，获取用户信息，直接跳转至 相应的业务模块；
// 					axiosInstance.defaults.headers['token'] = token
// 					localset('access_token', token)
// 					localset('loginType', 'miniProgram')
// 					home()
// 				} else {
// 					failed()//  否则验证失败，重新登录，并且绑定员工openid；
// 				}
// 			}).catch(() => {
// 				failed()
// 			})
// 		} else { //openId 获取为空
// 			failed()
// 		}
// 	}).catch(() => {
// 		failed()
// 	})
// }

//微信公众号
function weixinLogin (query, callback) {
  if (query.code) {
    api['user/getOpenId']({
      'code': query.code,
      'companySuper': query.compId || '',
      'corpId': query.corpId || '',
      'czly': 0,//操作来源 0公众号 1小程序  已废弃 只限公众号使用
    }).then((res) => {
      var openId = res.data ? res.data.openid : ''
      if (openId) { //如果openid 存在 ； 验证是否存在企业表中，绑定员工
        localset('openId', openId)
        api['user/wxLogin']({
          'openId': openId,
          'compId': query.compId
        }).then((res1) => {
          var token = res1.data || ''
          if (token) { // 如果验证通过；存储token，获取用户信息，直接跳转至 相应的业务模块；
            axiosInstance.defaults.headers['token'] = token
            localset('access_token', token)
            localset('loginType', 'wxWeb')
            try {
              api['user/getLoginUserInfo']({}).then((res2) => {
                if (_this) {
                  _this.$store.commit('SET_USERINFO', res2.data)
                }
                localset('userInfo', res2.data)
                wxRedirect(query)
              })
            } catch (error) {
              wxRedirect(query)
            }
          } else {
            fail(callback)//  否则验证失败，重新登录，并且绑定员工openid；
          }
        }).catch(() => {
          fail(callback)
        })
      } else { //openId 获取为空
        fail()
      }
    }).catch(() => {
      fail(callback)
    })
  }else if(query.phone){
    api['user/wxLogin']({
      'phone' : query.phone,
      'compId': query.compId,
      'corpId': query.corpId,
      'khlx' : 1
    }).then((res1) => {
      var token = res1.data || ''
      if (token) { // 如果验证通过；存储token，获取用户信息，直接跳转至 相应的业务模块；
        axiosInstance.defaults.headers['token'] = token
        localset('access_token', token)
        localset('openId', query.openId)
        localset('loginType', 'wxXcx')
        try {
          api['user/getLoginUserInfo']({}).then((res2) => {
            if (_this) {
              _this.$store.commit('SET_USERINFO', res2.data)
            }
            localset('userInfo', res2.data)
            home(callback)
          })
        } catch (error) {
          wxRedirect(query)
        }
      } else {
        fail(callback)//  否则验证失败，重新登录，并且绑定员工openid；
      }
    }).catch(() => {
      fail(callback)
    })
  } else {
    fail()
  }
}

//福卡单点登录
export function fkLogin (query, callback) {
  if (query.code) {
    api['user/getFkAccessToken']({
      'code': query.code,
      'corpId': query.corpId || ''
    }).then((res) => {
      var accessToken = res.data ? res.data.accessToken : ''
      var openId  = res.data ? res.data.openId : ''
      if (accessToken) { //如果openid 存在 ； 验证是否存在企业表中，绑定员工
        localset('accessToken', accessToken)
        localset('openId', openId)
        api['user/fkLogin']({
          'accessToken': accessToken,
          'openId': openId,
          'corpId': query.corpId
        }).then((res1) => {
          var token = res1.data || ''
          if (token) { // 如果验证通过；存储token，获取用户信息，直接跳转至 相应的业务模块；
            axiosInstance.defaults.headers['token'] = token
            localset('access_token', token)
            localset('loginType', FUKA_CONFIG.fukaTag)
            
            try {
              store.dispatch('getUserInfo').then(res2 => {
                wxRedirect(query)
              })
            } catch (error) {
              // console.log('[user-getLoginUserInfo] - err', error)
              wxRedirect(query)
            }
          } else {
            fail(callback)//  否则验证失败，重新登录，并且绑定员工openid；
          }
        }).catch((err) => {
          // console.log('[user-fkLogin] - err', err)
          fail(callback)
        })
      } else { //openId 获取为空
        fail()
      }
    }).catch((err) => {
      // console.log('[user-getFkAccessToken] - err', err)
      fail(callback)
    })
  }else {
    fail()
  }
}
/**
 * 单点登录重定向 obj
 * @param params 后台需要传入的参数 { a:1, b:2 }
 */
async function redirect (params) {
  var ssoPage = params.ssoPage,
    ssoCplx = params.ssoCplx,
    ssoDjlx = params.ssoDjlx, //单据类型
    appFrom = params.app_from || '',
    pageType = params.pageType || ''
  delete params.ssoPage
  delete params.ssoCplx
  delete params.ssotoken
  delete params.loginType
  delete params.ssoDjlx
  delete params.pageType
  delete params.appFrom
  var userInfo = localget('userInfo')
  var orderId = params.ssoOrderId || ''
  var orderNo = ''
  var travelNo = ''
  var workItemId = ''

  if (userInfo.empInfo.ssoJsonParam && appFrom !== 'amap_123') {
    let ssoJsonParam = JSON.parse(userInfo.empInfo.ssoJsonParam)
    orderId = ssoJsonParam.orderId
    workItemId = ssoJsonParam.workItemId
    orderNo = ssoJsonParam.orderNo
    travelNo = ssoJsonParam.travelNo

    if (!orderId && orderNo) {
      try {
        if (ssoPage === 'pay') {
          orderId = await Business.getOrderIdByOrderNo({ orderNo, findType: 2 })
        } else {
          orderId = await Business.getOrderIdByOrderNo({ orderNo })
        }
      } catch (error) {
        // 查不到订单 跳到订单列表上去
        ssoPage = 'order'
        throw error
      }
    }

    // 使用一次就删掉
    // delete userInfo.empInfo.ssoJsonParam
    // localset('userInfo', userInfo)
  }

  let obj={
    '11001':'/tk/tkOrderDetail',
    '11002':'/tk/tkRefundDetail',
    '11003':'/tk/tkChangeDetail',
    '11004':'/tk/tkOrderDetail',
    '11005':'/tk/tkRefundDetail',
    '11006':'/tk/tkChangeDetail',
    '11007':'/ht/htOrder/htOrderDetail',
    '11008':'/ht/htOrder/htRefundDetail',
    '11009':'/tr/OrderDetail',
    '11010':'/tr/RefundDetail',
    '11011':'/tr/ChangeDetail',
    '11018':'/car/carOrderDetail',
    '11023':'/visa/OrderDetail',
    '11028':'/restRoom/order',
    '11029':'/fastCheck/order',
    '11030':'/checkIn/order',
    '11031': '/guestPass/order',
    '':'/allOrder?findType=1'
  }

  // 是否是高德的标识 #pageType 默认1,	1：订单详情页面 2:12306登录页面
  if (appFrom == 'amap_123' && pageType) {
    if (pageType == 1) {
      ssoPage = 'detail'
      ssoDjlx = '11009'
    } else if (pageType == 2) {
      jump('/tr/trLogin12306')
      return
    }
  }

  switch (ssoPage) {
    case 'query':
      switch (ssoCplx) {
        case $dict.PRO_TYPE.tk: // 国内机票查询页
          jump('/tk/tkQuery')
          break
        case $dict.PRO_TYPE.tkIntel:// 国际机票查询页
          jump('/tk/tkQuery')
          break
        case $dict.PRO_TYPE.hotel:// 酒店查询页
          jump('/ht/htQuery')
          break
        case $dict.PRO_TYPE.tr:// 火车查询页

          if (params && "gt_123" == params["app_from"]) {
            //如果是从高铁123 跳转过来，根据传递过来的站点信息查询,直接跳转到列表页
            jump('tr/trList')
          }else {
            jump('/tr/trQuery')
          }

          break
        case $dict.PRO_TYPE.car:// 用车查询页
          jump('/car/carQuery')
          break
        case $dict.PRO_TYPE.visa:// 签证查询页
          jump('/visa')
          break
      }
      break
    case 'order':
      jump('/allorder')
      break
    case 'approval':
      jump('/approval/Detail')
      break
    case 'detail': // 各详情
      jump(obj[ssoDjlx])
      break
    case 'index': // 主页
      jump('/home')
      break
    case 'allorder':// 全部订单列表
      jump('/allorder')
      break
    case 'pay':// 全部订单列表
      jump('/payment')
      break
    case 'zxkf':// 在线客服
      jump('/service')
      break
    default:
      jump('/login')
      break
  }

  /**
   * 单点登录
   * cplx: 根据产品类型跳转到对应产品
   * type: ssoPage：产品的查询页面， ssoCplx：产品的列表页面， 剩余的属性是需要填入页面的参数 ...
   */
  function jump (baseURL) {
    if (orderId) {
      if (ssoPage === 'pay') {
        location.href=location.origin+'/#'+baseURL+'?orderId='+orderId+'&orderType='+ssoDjlx
      } else {
        if(workItemId){
          location.href=location.origin+'/#'+baseURL+'?id='+orderId+'&workItemId='+workItemId+'&orderType='+ssoDjlx+'&active=1'
        }else if(ssoDjlx==='11007' || ssoDjlx==='11008'){
          location.href=location.origin+'/#'+baseURL+'/'+orderId+'/0'+'?orderId='+orderId
        }else if(ssoDjlx==='11009' || ssoDjlx==='11010' || ssoDjlx==='11011'){
          location.href=location.origin+'/#'+baseURL+'/'+orderId+'?orderId='+orderId
        }else{
          location.href=location.origin+'/#'+baseURL+'?orderId='+orderId
        }
      }
    } else if (orderNo) {
      location.href=location.origin+'/#'+baseURL+'?orderId='+orderNo
    } else if (travelNo) {
      location.href=location.origin+'/#'+baseURL+'?ccsqdId='+travelNo
    } else {
      location.href = location.origin + '/#' + baseURL
    }

    window.location.reload()
  }
}

/**
 * 微信单点登录重定向
 */
function wxRedirect( obj){
  let data={
    trainList:'/tr/trQuery',
    hotelList:'/ht/htQuery',
    flightList:'/tk/tkQuery',
    flightRefundTicket:'/tk/tkRefundApply',
    flightChangeTicket:'/tk/tkChangeApply',
    flightDetail:'/tk/tkOrderDetail',
    tkInterNeed:'/tk/tkQuery',
    trainRefundTicket:'/tr/ApplyRefund',
    trainChangeTicket:'/tr/ApplyAlter',
    trainDetail:'/tr/OrderDetail',
    hotelRefund:'/ht/htOrder/htRefund',
    hotelDetail:'/ht/htOrder/htOrderDetail',
    htInterNeed:'/ht/htQuery',
    MyOrder:'/allOrder',
    home:'/home',
    carQuery:'/car/carQuery',
    tkQuery:'/tk/tkQuery',
    htQuery:'/ht/htQuery',
    trainQuery: '/tr/trQuery',
    visa:'/visa',
    '':'/index'
  }

  function jump (path) {
    if (!path) {
      window.location.href = window.location.origin + '/#/home'
    }else if(path=='index'){
      window.location.href = window.location.origin+'/#/login'
    } else if (path.indexOf('Query') > -1||path==='/visa') {
      window.location.href = window.location.origin+'/#'+path
    }else if(obj.orderNo){
      window.location.href = window.location.origin+'/#'+path+'?orderId='+obj.orderNo+'&id='+obj.orderNo
    }else if(obj.approvalNo) {
      window.location.href = window.location.origin+'/#'+path+'?ccsqdId='+obj.approvalNo+'&tripType='+obj.tripType
    } else if(obj.tripType){
      window.location.href = window.location.origin+'/#'+path+'?tripType='+obj.tripType
    } else {
      window.location.href = window.location.origin + '/#' + path
    }
    localset('href', location.href)
  }

  try {
    jump(data[obj.searchType])
  } catch (error) {
    window.location.href = window.location.origin + '/#/home'
  }
}
